export default __webpack_public_path__ + "static/media/epi-constructor-civil.3003dbc1.jpg";